import { useState } from 'react'
import { getWindow, hasWindow } from '@ztechapps/common.utils'

// The browser's `Notification.permission`, `unsupported` for a browser with no Notification API.
export type DesktopNotificationPermission = NotificationPermission | 'unsupported'

export type UseDesktopNotificationPermissionResult = {
  permission: DesktopNotificationPermission
  // Asks the browser for permission; call it from a click only (browsers ignore a prompt raised elsewhere).
  requestPermission: () => Promise<void>
}

const readPermission = (): DesktopNotificationPermission =>
  hasWindow() && getWindow().Notification ? getWindow().Notification.permission : 'unsupported'

export const useDesktopNotificationPermission = (): UseDesktopNotificationPermissionResult => {
  const [permission, setPermission] = useState<DesktopNotificationPermission>(readPermission)

  const requestPermission = async () => {
    if (permission === 'unsupported') return
    setPermission(await getWindow().Notification.requestPermission())
  }

  return { permission, requestPermission }
}
